import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { Router } from '@angular/router';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Modal Component
 */
let VerifyOfficeModalComponent = class VerifyOfficeModalComponent {
    constructor(httpClient, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.successColor = '';
        this.backColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    close() {
        this.router.navigateByUrl('verify');
        this.modal.destroy();
    }
    submit() {
        this.httpClient.post('user/setpersonalverificationmethod', {
            verification_method_code: 'office'
        }).subscribe((data) => {
            this.success();
            this.closeModal();
        });
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
VerifyOfficeModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
VerifyOfficeModalComponent = __decorate([
    Component({
        selector: 'ecd-verify-office-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify-office-modal.component.html")).default
    })
], VerifyOfficeModalComponent);
export { VerifyOfficeModalComponent };
